<template>
	<div class="">
		<div class="zhuanye-intro">
			<div class="topinde">
				<div class="topinde_l">
					<div class="intro1">
						<div class="intro1-tit">
							<div class="wl"></div>
							<span>就业行业分布</span>
						</div>
						<div class="intro1_r">
							<div class="nr_inde" v-for="(item,index) in  majorData.hangye">
								<span class="sdsd">{{item}}</span>
								<div class="nr">
									<span :style="{width:majorData.hangyerate[index]+'%'}"></span>
								</div>
								<span>{{majorData.hangyerate[index]}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="topinde_r">
					<div class="intro1-tit">
						<div class="wl"></div>
						<span>就业地区</span>
					</div>
					<kaoyanyujiuye :majorData="majorData"></kaoyanyujiuye>
				</div>
			</div>
			<div class="intro1">
				<div class="intro1-tit">
					<div class="wl"></div>
					<span>工资情况</span>
				</div>
				<pay :majorData="majorData"></pay>
			</div>
			<div class="intro1">
				<div class="intro1-tit">
					<div class="wl"></div>
					<span>就业岗位</span>
				</div>
				<div class="wenduan">
					<div style="width: 80%;display: flex;flex-direction: row;flex-wrap:wrap">
            <div style="padding: 15px;" v-for="item in  majorinfo.jiuyegangwei">{{item}}</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import kaoyanyujiuye from "../../tubiao/kaoyanyujiuye_biao.vue"
import pay from "../../tubiao/pay.vue"
	export default {
		name: "",
		components: {
			kaoyanyujiuye,
      pay
		},
		data() {
			return {
        majorData:{},
        majorinfo:{}

      }
		},
    props:{
      id:{type:String,default:''}
    },
    created() {
      console.log(222)
      let _this = this;
      _this.$http.get(_this.$resourcesUrl + "/major/" + this.id + "/majorData.json").then(function(
      	response) {
          _this.majorData = response

        })
        _this.$http.get(_this.$resourcesUrl + "/major/" + this.id + "/majorinfo.json").then(function(
        	response) {
        	_this.majorinfo = response
          if (response.jiuyegangwei != null && response.jiuyegangwei != '') {
            response.jiuyegangwei = response.jiuyegangwei.replace(/&quot;/g ,"")
            response.jiuyegangwei = response.jiuyegangwei.replace("[" ,"")
            response.jiuyegangwei = response.jiuyegangwei.replace("]" ,"")
            response.jiuyegangwei = response.jiuyegangwei.replace("<p>" ,"")
            response.jiuyegangwei = response.jiuyegangwei.replace("</p>" ,"")
            _this.majorinfo.jiuyegangwei = response.jiuyegangwei.split(",")
          	// _this.majorinfo.jiuyegangwei = JSON.parse(response.jiuyegangwei)
          }
        })
    },
		methods: {

		}


	}
</script>

<style scoped>
	.zhuanye-intro{padding-bottom: 40px;}
	.fenbuBox{border-bottom: none!important;}
	.topinde_l{width: 50%; display: flex;flex-direction: column;}
	.topinde_r{width: 50%;}
	.intro1_r{width: 716px; display: flex;flex-direction: column;margin-left: 20px;border-bottom: 1px solid rgba(0, 0, 0, 0.050980392156862744);}
	.wenduan{padding-left: 20px;}
	.wenduan p{padding-left: 20px;font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #666666;}
	.nr_inde{display: flex;align-items: center;box-sizing: border-box;margin-bottom: 15px;}
	.nr_inde .nr{width: 200px;height: 20px;background: #ECF9FF;display: flex;align-items: center;margin-left: 20px;}
	.nr_inde .nr span{width: 25%;height: 20px;background: #29A7E1;border-radius: 0 16px 16px 0;}
	.nr_inde .sdsd{font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #666666;width: 200px;}

	.zhanwei {
		width: 100%;
		height: 46px;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	.topinde{width: 100%;display: flex;}
	.intro1{
		margin-bottom: 20px;
	}
	.intro1-tit{
		margin-bottom: 15px;
	}
	.intro1-tit span {
		margin-left: 10px;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 20px;
		display: flex;
		align-items: center;
	}

	.wl {
		width: 6px;
		height: 22px;
		border-radius: 0px 4px 4px 0px;
		background: #F21323;
	}

	.intro1-tit {
		display: flex;
	}


	@media (max-width:750px) {
		.topinde{flex-direction: column;}
		.topinde_r{width: 100%;}
		.intro1_r{width: 100%;}
	}
</style>



// WEBPACK FOOTER //
// src/views/information/majorinfo/kaoyanyujiuye.vue